import React from 'react';
import { useParams } from "react-router-dom";
import SideNavBar from '../../components/headers/sidenavbar/SideNavBar';
import UserData from '../../components/headers/topnavbar/UserData';
import AddLessonChild from '../../components/teamleaderchild/AddLessonChild';

function AddLesson() {
    let { id } = useParams();
    return (
        <div>
           <div id="wrapper">
                <SideNavBar />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <UserData />
                        <div className="container-fluid">
                            <AddLessonChild id={id}/>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    )
}

export default AddLesson;
